// Filename: models/questionnaire/questionnaire.js
define('models/payment/payment-method',[
    "underscore",
    "backbone",
    "services/i18n",
    // services
    "services/api",
], function (_, Backbone, i18n, API) {

    var MPaymentMethod = Backbone.Epoxy.Model.extend({
        idAttribute: 'id',
        validateSingle: true,
        urlRoot: API.url("payments/{{payId}}/{{method}}/{{paymentType}}"),

        defaults: {
            paymentType: "creditcard",
            cardNumber: "",
            cardType: "",
            expirationDate: "******",
            securityCode: "",

            firstName: "",
            middleName: "",
            lastName: "",
            phoneNumber: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            postalCode: "",
            country: "",
            region: "",
        },

        computeds: {
            expirationMonth: {
                deps: ["expirationDate"],
                get: function(expirationDate) {
                    return expirationDate.substring(4, 6);
                },
                set: function(value) {
                    var expirationDate = this.get('expirationYear') + value;
                    return {
                        expirationDate: expirationDate,
                    };
                }
            },

            expirationYear: {
                deps: ["expirationDate"],
                get: function(expirationDate) {
                    return expirationDate.substring(0, 4);
                },
                set: function(value) {
                    var expirationDate = value + this.get('expirationMonth');
                    return {
                        expirationDate: expirationDate,
                    };
                }
            },
        },

        getPaymentType: function() {
            return this.get('paymentType');
        },

        getCardNumber: function() {
            return this.get('cardNumber');
        },

        getCardType: function() {
            return this.get('cardType');
        },

        getExpirationDate: function() {
            return this.get('expirationDate');
        },

        getSecurityCode: function() {
            return this.get('securityCode');
        },

        isCreditCardPayment: function() {
            return this.get('paymentType') === 'creditcard';
        },

        ////////////////
        // validation //
        ////////////////
        // Used to validate expiration date which is split in the form
        validate: function(attrs, options) {
            var errors = [];

            if (this.get("expirationMonth") === "**") {
                errors.push({
                    attribute: "expirationMonth",
                    error: i18n.t("payment:error_card_expiration_month_blank"),
                });
            }

            if (this.get("expirationYear") === "****") {
                //don't want to display 2 messages a the same time but We want to mark the expiration year as invalid
                if (
                    options.singleError &&
                    errors.length > 0 &&
                    errors[0].attribute === "expirationMonth"
                ) {
                    errors.push({ attribute: "expirationYear", error: "" });
                } else {
                    errors.push({
                        attribute: "expirationYear",
                        error: i18n.t(
                            "payment:error_card_expiration_year_blank"
                        ),
                    });
                }
            }

            if (errors.length > 0) {
                return errors;
            }
        },

        validation: {
            cardNumber: {
                presence: true,
                format: {
                    pattern: /^[0-9]{15,16}$/,
                    message: i18n.t("payment:error_card_number_invalid"),
                },
                luhnCheck: {
                    message: i18n.t("payment:error_card_number_invalid"),
                },
            },
            cardType: {
                presence: true,
            },
            expirationDate: {
                presence: true,
                length: {
                    is: 6,
                    message: "must contain a month and a year",
                },
            },
            securityCode: {
                presence: true,
                format: {
                    pattern: /^[0-9]{3,4}$/,
                    message: i18n.t("payment:error_card_cvv_blank"),
                },
            },
            firstName: {
                presence: true,
            },
            middleName: {
                presence: false,
            },
            lastName: {
                presence: false,
            },
            addressLine1: {
                presence: true,
            },
            addressLine2: {
                presence: false,
            },
            city: {
                presence: true,
            },
            phoneNumber: {
                presence: true,
            },
            country: {
                presence: true,
            },
            region: {
                presence: true,
            },
            postalCode: {
                presence: true,
            },
        },
    });

    // Return the model for the module
    return MPaymentMethod;
});

